/**
 * Footer Component
 * 
 * Class component for Chrome 68 compatibility
 */

import React, { Component } from 'react';

class Footer extends Component {
    render() {
        var currentYear = new Date().getFullYear();
        
        return React.createElement('footer', { className: 'bb-footer' },
            React.createElement('div', { className: 'container' },
                React.createElement('p', { className: 'mb-2' },
                    '📱 4.3AppStore - Android 4.3 apps for BlackBerry OS 10 and other legacy devices'
                ),
                // React.createElement('p', { className: 'mb-2' },
                //     'Data updated daily from ',
                //     React.createElement('a', { href: 'https://f-droid.org', target: '_blank', rel: 'noopener noreferrer' }, 'F-Droid'),
                //     ' and ',
                //     // ', ',
                //     React.createElement('a', { href: 'https://uptodown.com', target: '_blank', rel: 'noopener noreferrer' }, 'Uptodown'),
                //     // ', ',
                //     // React.createElement('a', { href: 'https://apkmirror.com', target: '_blank', rel: 'noopener noreferrer' }, 'APKMirror'),
                //     // ', and ',
                //     // React.createElement('a', { href: 'https://apkpure.com', target: '_blank', rel: 'noopener noreferrer' }, 'APKPure')
                // ),
                React.createElement('p', { className: 'text-muted small mb-0' },
                    'Not affiliated with BlackBerry or app sources | Made by ',
                    React.createElement('a', { href: 'https://github.com/imantsk', target: '_blank', rel: 'noopener noreferrer' }, 'Imantsk'),
                )
            )
        );
    }
}

export default Footer;
